import { Text, VStack } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import FileGridLoader from './FileGridLoader'
import FolderGridLoader from './FolderGridLoader'

const MLGridLoader = (): ReactElement | null => {
  const { t } = useTranslation()
  return (
    <VStack alignItems="flex-start" spacing={8}>
      <Fragment>
        <Text fontWeight="semibold" color="appSlate">
          {t('folders', 'Folders')}
        </Text>
        <FolderGridLoader />
      </Fragment>
      <Fragment>
        <Text fontWeight="semibold" color="appSlate">
          {t('files', 'Files')}
        </Text>
        <FileGridLoader />
      </Fragment>
    </VStack>
  )
}

export default MLGridLoader
